if (!customElements.get('product-form')) {
  class ProductForm extends HTMLElement {
    constructor() {
      super();
      if (this.hasChildNodes()) this.init();
    }

    init() {
      this.form = this.querySelector('.js-product-form');
      if (this.form) {
        this.cartDrawer = document.querySelector('cart-drawer');
        this.submitBtn = this.querySelector('[name="add"]');

        if (theme.settings.afterAtc !== 'no-js') {
          this.form.addEventListener('submit', this.handleSubmit.bind(this));
        }
      }
    }

    /**
     * Handles submission of the product form.
     * @param {object} evt - Event object.
     */
    async handleSubmit(evt) {
      if (evt.target.id === 'product-signup_form') return;

      evt.preventDefault();

      if (this.submitBtn.getAttribute('aria-disabled') === 'true') return;

      if (theme.settings.vibrateOnATC && window.navigator.vibrate) {
        window.navigator.vibrate(100);
      }

      this.errorMsg = null;
      this.setErrorMsgState();

      // Disable "Add to Cart" button until submission is complete.
      this.submitBtn.setAttribute('aria-disabled', 'true');
      this.submitBtn.classList.add('is-loading');

      const formData = new FormData(this.form);
      let sections = 'cart-icon-bubble';
      if (this.cartDrawer) {
        sections += `,${this.cartDrawer.closest('.shopify-section').id.replace('shopify-section-', '')}`;
      }

      formData.append('sections_url', window.location.pathname);
      formData.append('sections', sections);

      const fetchRequestOpts = {
        method: 'POST',
        headers: {
          Accept: 'application/javascript',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: formData
      };

      try {
  // ⚡ 1. Button feedback instantly (0ms)
  this.submitBtn.classList.remove('is-loading');
  this.submitBtn.classList.add('is-success');

  // ⚡ 2. Open drawer instantly with loading state (0ms)
  if (this.cartDrawer) {
    document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:open'));
    this.cartDrawer.classList.add('is-updating'); // shows spinner inside drawer
  }

  // ⏳ 3. Wait for BOGOS in background
  const response = await fetch(theme.routes.cartAdd, fetchRequestOpts);
  const data = await response.json();

  // ✅ 4. Update drawer with real data when ready
  if (this.cartDrawer) {
    this.cartDrawer.classList.remove('is-updating');
    this.cartDrawer.renderContents(
      data,
      !this.closest('quick-add-drawer') && theme.settings.afterAtc === 'drawer'
    );
  }



  let error = typeof data.description === 'string' ? data.description : data.message;
  if (data.errors && typeof data.errors === 'object') {
    error = Object.entries(data.errors).map((item) => item[1].join(', '));
  }
  if (data.status) this.setErrorMsgState(error);
  if (!response.ok) throw new Error(response.status);

  if (theme.settings.afterAtc === 'page') {
    setTimeout(() => { window.location.href = theme.routes.cart; }, 100);
  } else {
    ProductForm.updateCartIcon(data);

    const quickAddDrawer = this.closest('quick-add-drawer');
    if (quickAddDrawer) quickAddDrawer.addedToCart();

    if (this.cartDrawer) {
      // ✅ Single renderContents call only
      this.cartDrawer.renderContents(
        data,
        !quickAddDrawer && theme.settings.afterAtc === 'drawer'
      );
    } else if (window.location.pathname === theme.routes.cart) {
      const cartItems = document.querySelector('cart-items');
      if (cartItems) {
        if (cartItems.dataset.empty === 'true') {
          window.location.reload();
        } else {
          cartItems.refresh();
        }
      }
    }

    this.dispatchEvent(new CustomEvent('on:cart:add', {
      bubbles: true,
      detail: { cart: data, variantId: data.variant_id }
    }));
  }
} catch (error) {
        console.log(error); // eslint-disable-line
        this.dispatchEvent(new CustomEvent('on:cart:error', {
          bubbles: true,
          detail: {
            error: this.errorMsg?.textContent
          }
        }));

        if (this.cartDrawer) this.cartDrawer.refresh(true);
      } finally {
        // Re-enable 'Add to Cart' button (short success state for speed).
        this.submitBtn.classList.add('is-success');
        this.submitBtn.removeAttribute('aria-disabled');
        setTimeout(() => {
          this.submitBtn.classList.remove('is-loading');
          this.submitBtn.classList.remove('is-success');
        }, 200);
      }
    }

    /**
     * Updates the cart icon count in the header.
     * @param {object} response - Response JSON.
     */
    static updateCartIcon(response) {
      const cartIconBubble = document.getElementById('cart-icon-bubble');
      if (cartIconBubble) {
        cartIconBubble.innerHTML = response.sections['cart-icon-bubble'];
      }
    }

    /**
     * Shows/hides an error message.
     * @param {string} [error=false] - Error to show a message for.
     */
    setErrorMsgState(error = false) {
      this.errorMsg = this.errorMsg || this.querySelector('.js-form-error');
      if (!this.errorMsg) return;

      this.errorMsg.hidden = !error;
      if (error) {
        this.errorMsg.innerHTML = '';
        const errorArray = Array.isArray(error) ? error : [error];
        errorArray.forEach((err, index) => {
          if (index > 0) this.errorMsg.insertAdjacentHTML('beforeend', '<br>');
          this.errorMsg.insertAdjacentText('beforeend', err);
        });
      }
    }
  }

  customElements.define('product-form', ProductForm);
}
